import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { resetStreams, setCurrentCameras } from "../../../store/cameras/actions";
import service from '../../../services/ocularis';
import InitLivemodePaneComponent from "../InitLivemodePaneComponent";
import LayoutLiveContainer from "../../../containers/LayoutLiveContainer";
import { ApplicationState } from '../../../store';
import { LayoutState } from '../../../store/layouts/types';

const {CONFIG} = window;
const footerHeight = typeof (CONFIG) !== 'undefined' ? window.CONFIG.footer.height : 0;

//pane here is not correct. It uses to avoid TS error. Correct pane will assigned  LayoutComponent's children
const LivemodeComponent = () => {
  const dispatch = useDispatch();
  const {initialCameras} = useSelector<ApplicationState, LayoutState>(state => state.layouts);

  useEffect(() => {
    dispatch(setCurrentCameras(initialCameras));
    return () => {
      service.cancelAllRequests();
      dispatch({type: 'cancelDeviceStatus'});
      dispatch(resetStreams())
    }
  }, []);

  return (
    <div className='LiveModeWrapper'
         style={{
           height: `${100 - footerHeight}vh`,
           backgroundColor: `#000000`
         }}
    >
      <LayoutLiveContainer>
        <InitLivemodePaneComponent pane={0}/>
      </LayoutLiveContainer>
    </div>
  )
};


export default LivemodeComponent